module.exports = __webpack_public_path__ + "static/media/toilet180.97c97139.png";